import { createContext } from "react";
import useAgents from "../hooks/data/useAgents";

export interface IAgentsContext extends ReturnType<typeof useAgents> {

};

const AgentsContext = createContext<IAgentsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default AgentsContext